import { mapActions } from 'vuex';
import Analytics from '@/mixins/Analytics';
import GaiaGraphQLClient from '@/api/graphql/GaiaGraphQLClient';
import { getOffersActiveTabKey, getOffersViewModeKey } from '@/constants/offers';

const methods = {
  ...mapActions({
    clearUser: 'clearUser',
    removeFeatureFlags: 'removeFeatureFlags',
    unsubscribeCurrentUser: 'unsubscribeCurrentUser',
    clearAuctions: 'auctions/clearAuctions',
    clearCardSwitcherPreference: 'uiSettings/clearCardSwitcherPreference',
    deleteFirebaseRegistation: 'deleteFcmRegistration',
    resetMarketplaceParams: 'marketplaceRouter/resetMarketplaceParams',
    resetMarketplaceView: 'marketplaceView/resetMarketplaceView',
    clearVdpVersionPreference: 'pandaMfe/clearVdpVersionPreference',
    updateEulaReviewBannerVisibility: 'marketplaceView/updateEulaReviewBannerVisibility',
    resetAnnouncements: 'announcements/resetAnnouncements',
  }),
  async logout() {
    const userId = this.$store.getters.currentUser?.id;
    if (userId) {
      localStorage.removeItem(getOffersActiveTabKey(userId));
      localStorage.removeItem(getOffersViewModeKey(userId));
    }
    this.resetAnnouncements();
    await this.unsubscribeCurrentUser();
    await this.deleteFirebaseRegistation();
    // Clear the module so that a user can logout without
    // getting caught up in the redirects. - ETC
    await this.clearCardSwitcherPreference();
    this.resetMixpanel();
    await this.clearUser();
    await this.removeFeatureFlags();
    await this.resetMarketplaceParams({ persistAfterLeave: true });
    await this.resetMarketplaceView();
    this.clearVdpVersionPreference();
    this.updateEulaReviewBannerVisibility(true); // reset eula banner on logout
    GaiaGraphQLClient().stopAll();
    localStorage.removeItem('acv-seller-control-room-authorization');
    localStorage.removeItem('acv-seller-control-room-auction');
  },
};

export default {
  methods,
  mixins: [Analytics],
};
